import {
  IconUser,
  IconCircleKey,
  IconUsersGroup,
  IconBuildingBroadcastTower,
  IconHash,
  IconSpeakerphone,
} from "@tabler/icons-react"
import { ChatType } from "../../../orval/gen/model"

export function ChatIcon({
  chatType,
}: {
  chatType: ChatType
}): React.ReactNode {
  switch (chatType) {
    case "Direct":
      return <IconUser size={14} />
    case "PrivateGroup":
      return <IconCircleKey size={14} />
    case "PublicGroup":
      return <IconUsersGroup size={14} />
    case "Broadcast":
      return <IconBuildingBroadcastTower size={14} />
    case "Feed":
      return <IconHash size={14} />
    case "BroadcastFeed":
      return <IconSpeakerphone size={14} />
    default:
      return <IconUser size={14} />
  }
}
